<template>
    <div class="offcanvas offcanvas-end offcanvas-01" id="offcanvasCreate" tabindex="-1"
        aria-labelledby="offcanvasCreateLabel">
        <div class="offcanvas-header">
            <h5 class="text-dark" id="offcanvasCreateLabel">{{ mode }} Service Link Data </h5>
            <button class="btn btn-danger btn-sm" type="button" data-bs-dismiss="offcanvas" aria-label="Close"
                ref="btnClose">
                <i class="ic-close"></i>
            </button>
        </div>
        <div class="offcanvas-body">
            <div class="row">
                <form class="row align-end" v-on:submit.prevent="submitForm" enctype="multipart/form-data">
                    <div class="col-md-12 mb-16">
                        <label for="">Title</label>
                        <input type="text" class="form-control" v-model="item.title" />
                        <ErrorSpan :error="errors.title" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Subtitle</label>
                        <ckeditor v-model="item.subtitle" :config="editorConfig"></ckeditor>
                        <ErrorSpan :error="errors.subtitle" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <label for="">Product/Service</label>
                        <select name="product_service_id" class="form-select" :class="{ 'border-red': errors.product_service_id }"
                            v-model="item.product_service_id">
                            <option value="" disabled selected>Select Parent</option>
                            <option v-for="item in products" :key="item.id" :value="item.id">{{ item.name }}</option>
                        </select>
                        <ErrorSpan :error="errors.product_service_id" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <label for="">Link Type</label>
                        <select name="parent_id" class="form-select" v-model="item.link_type">
                            <option value="" disabled selected>Select Parent</option>
                            <option v-for="item, key in link_types" :key="key" :value="key">{{ item }}</option>
                        </select>
                        <ErrorSpan :error="errors.link_type" />
                    </div>

                    <div class="col-md-12 mb-16">
                        <label for="">Link</label>
                        <input type="text" class="form-control" v-model="item.link" />
                        <ErrorSpan :error="errors.link" />
                    </div>
                    <div class="col-md-6 mb-16">
                        <label for="">Display Order</label>
                        <input type="number" min="1" @input="item.order_by = item.order_by < 1 ? '' : item.order_by"
                            class="form-control" :class="{ 'border-red': errors.order_by }" v-model="item.order_by" />
                        <ErrorSpan :error="errors.order_by" />
                    </div>

                    <div class="col-md-6 mb-16">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault1"
                                v-model="item.status" true-value="1" false-value="0" />
                            <label class="form-check-label" for="flexSwitchCheckDefault">Status</label>
                        </div>
                    </div>
                    <hr>
                    <div class="col-md-12">
                        <button type="button" aria-label="Close" data-bs-dismiss="offcanvas" class="btn btn-red mr-16">
                            <i class="ic-close mr-8"></i>Cancel
                        </button>
                        <button v-if="!isLoading" class="btn btn-green" type="submit">
                            <i class="ic-checkmark mr-8"></i>Save
                        </button>
                        <button v-else class="btn btn-green" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
  
<script>
import CreateMixin from "@/mixins/create.vue"
import ErrorSpan from "@/components/errorspan.vue";
import CKEditor from 'ckeditor4-vue';

export default {
    name: "ServiceLinkModal",
    mixins: [CreateMixin,],
    components: {
        ErrorSpan, ckeditor: CKEditor.component,
    },
    data() {
        return {
            url: 'service-links',
            fetch_module: 'FETCH_SERVICE_LINKS',
            mode: "",
            products: [],
            link_types: {
                1: 'Internal',
                2: 'External',
            },
            editorConfig: {
                format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div'
            }

        };
    },

    mounted() {
        this.axios.get(process.env.VUE_APP_API_URL + 'service-links/products').then((response) => {
            this.products = response.data.data;
        });


        this.$root.$on('CREATE', () => {
            this.isEdit = false;
            this.errors = {};
            this.item = {};
            this.mode = "Add";

        });

        this.$root.$on('EDIT', (data) => {
            this.isEdit = true;
            this.item = { ...data };
            this.errors = {};
            this.mode = "Edit";

        });
    },

};
</script>
